import type { ParentSharedStudent } from '@/types';
import { formatDate, formatNumber, nextDueDate, tuitionStatus } from '@/lib/datetime';

interface ParentTuitionCardProps {
  student: ParentSharedStudent;
}

const STATUS_META = {
  paid: { label: '결제완료', badge: 'bg-secondary-100 text-secondary-900', icon: 'ri-checkbox-circle-line' },
  overdue: { label: '미납', badge: 'bg-accent-100 text-accent-800', icon: 'ri-error-warning-line' },
  upcoming: { label: '결제 예정', badge: 'bg-background-200 text-foreground-700', icon: 'ri-time-line' },
} as const;

export default function ParentTuitionCard({ student }: ParentTuitionCardProps) {
  const nextDate = nextDueDate(student.tuition_due_day);
  const { status } = tuitionStatus(student.tuition_due_day, student.tuition_last_paid_at);
  const meta = STATUS_META[status];

  return (
    <section className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
      <h2 className="flex flex-wrap items-center gap-2 text-sm font-bold text-foreground-950">
        <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
          <i className="ri-wallet-3-line"></i>
        </span>
        교습비
        <span
          className={`flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${meta.badge}`}
        >
          <i className={meta.icon}></i>
          {meta.label}
        </span>
      </h2>

      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
        <div className="rounded-lg border border-background-200 bg-primary-50 p-4">
          <p className="text-xs text-foreground-500">교습비</p>
          <p className="mt-1 text-xl font-bold text-primary-700">
            {student.tuition_fee ? `${formatNumber(student.tuition_fee)}원` : '미입력'}
          </p>
        </div>
        <div className="rounded-lg border border-background-200 bg-background-100 p-4">
          <p className="text-xs text-foreground-500">결제일</p>
          <p className="mt-1 text-xl font-bold text-foreground-900">
            {student.tuition_due_day ? `매월 ${student.tuition_due_day}일` : '미입력'}
          </p>
        </div>
        <div className="rounded-lg border border-background-200 bg-accent-50 p-4">
          <p className="text-xs text-foreground-500">다음 결제일</p>
          <p className="mt-1 text-xl font-bold text-accent-700">{formatDate(nextDate)}</p>
        </div>
      </div>
    </section>
  );
}